import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* verifyAccountPhone({ payload: { values, onSuccess, handledErrors } }) {

  try {
    yield call(fetch, { api: api.profile.phone_verify, data: values });

    onSuccess();
    yield put(actions.verifyAccountPhoneDone());
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.verifyAccountPhoneFailed,
      handledErrors,
      endpoint: api.profile.phone_verify.url
    });
  }
}

export const verifyAccountPhoneSaga = takeEvery(types.VERIFY_ACCOUNT_PHONE_REQUEST, verifyAccountPhone);